import { ActiveMenu } from "../../StateManagment/ActiveMenuItem";
import { Auth } from '../../StateManagment/Auth';
import { useContext } from "react";
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import { useHistory } from 'react-router-dom';
import { client } from "../../hooks/Client"
import usePersonaTerms from '../../hooks/usePersonaTerms';
import useSettings from '../../hooks/Settings.jsx';
import usePermissions from '../../hooks/usePermissions';

const PersonasExplainer = () => {
 // Context
 const [auth] = useContext(Auth)
 const { active, setActive, activeSubItem, setActiveSubItem } = useContext(ActiveMenu);

 // Hooks
 const history = useHistory()
 const personaTerms = usePersonaTerms()
 const { personasOn, housevisits, wervingsacties } = useSettings()

 // Zelfde poorten als het submenu in LeftSideBar.js. Deze lijst had er geen
 // enkele, dus hij beloofde 'Huishoudens' en 'Materialen' ook aan een
 // organisatie zonder die module — en 'Wervingsacties' ontbrak juist, terwijl
 // het menu het wél heeft. Twee lijsten van dezelfde onderdelen lopen uiteen
 // zodra er één poort bij komt; hier blijft dat zo lang deze lijst met de hand
 // wordt bijgehouden, dus houd hem naast het menu.
 // AI-CONTEXT: See docs/pitfalls.md#ui-sidebar-renders-its-menu-twice
 const { has, ready } = usePermissions()
 const canView = (key) => !ready || has(key)
 const housevisitsOn = housevisits && canView('housevisits.view')

const segmentSteps = [
  personasOn === 'flex' && canView('personas.view') && {
    name: personaTerms.plural,
    url: 'personas'
  },
  housevisitsOn && {
    name: 'Huishoudens',
    url: 'housevisitsoverview'
  },
  canView('forms.view') && {
    name: 'Formulieren',
    url: 'intakeforms'
  },
  housevisitsOn && {
    name: 'Materialen',
    url: 'materials'
  },
  housevisitsOn && wervingsacties && {
    name: 'Wervingsacties',
    url: 'wervingsacties'
  }
].filter(Boolean)

 return (
  <div className="main">
      <div className="main-container">
          <div className="page-header">
              <GroupsOutlinedIcon/>
              <h1>Ondersteuning</h1>
          </div>
          <div className='section-explainer-text-container'>
            <div>
              <p>Welkom bij ondersteuning, {auth?.ForName}. Hier kun je {personaTerms.pluralLower} en huisbezoeken beheren.</p>
            </div>
            <div id='segment-overview-steps-container'>
              {segmentSteps.map((step, index) => (
                <div 
                key={index} 
                className="segment-overview-step-container"
                onClick={() => {
                  history.push(`/${client}/${step.url}`);
                  setActive('personas');
                  setActiveSubItem(step.url)
                }}
                >
                  <div className="segment-overview-step-inner-container">
                    <div className="segment-overview-checked-name-container">
                      <div>
                        <p><b>{step.name}</b></p>
                      </div>
                    </div>
                    <p id='segment-overview-step-button'>Bekijk/aanpassen</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
  )
}

export default PersonasExplainer